/**
 * Common Switch Props
 */
export var switchProps = {
  size: [String, Number],
  value: null,
  loading: Boolean,
  disabled: Boolean,
  activeColor: String,
  inactiveColor: String,
  activeValue: {
    type: null,
    default: true
  },
  inactiveValue: {
    type: null,
    default: false
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@2.4.3@vant/es/switch/shared.js
// module id = null
// module chunks = 